/* istanbul ignore file */
import React from 'react';
import SingleAccountBreadcrumbs from 'domain/sales/account/shared/SingleAccountBreadcrumbs';
import { ActivitiesAndNotesBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useAccountId } from 'domain/sales/account/accountRouting';
import { useAccountUrl } from 'domain/shared/account';

const AccountTimelineBreadcrumbs = () => {
  const id = useAccountId();
  const { getTimelineUrl } = useAccountUrl();

  return (
    <SingleAccountBreadcrumbs>
      <ActivitiesAndNotesBreadcrumbItem link={getTimelineUrl(id)} />
    </SingleAccountBreadcrumbs>
  );
};

export default AccountTimelineBreadcrumbs;
